/* eslint-disable @typescript-eslint/no-explicit-any */
const iframeSenderIsNullMsg = "Cannot read properties of null (reading 'postMessage')";
const isIframeError = (err: any): boolean => err instanceof Error && err.message.includes(iframeSenderIsNullMsg);

export function ignoreIframeError(err: any) {
  return isIframeError(err) ? undefined : err;
}
